import { useState } from "react";
import styles from "./TermsAndConditions.module.css";
import RadioBtn from "../../assets/icons/RadioBtn";
import { errorToast } from "../../utils/makeToast";
import SwiftTandC from "./SwiftTandC";
import MainTandC from "./MainTandC";
interface TermsAndConditionsProps {
  onClickCheck: (state: boolean) => void;
  onClickProceed?: () => void;
}

interface AcceptedState {
  yes: boolean;
  no: boolean;
}
const TermsAndConditions: React.FC<TermsAndConditionsProps> = ({
  onClickCheck,
  onClickProceed,
}) => {
  const [accepted, setAccepted] = useState<AcceptedState>({
    yes: false,
    no: false,
  });
  const [error, setError] = useState("");
  const accountType = localStorage.getItem("altFinanceAccountType")||'';

  const handleToggleAccept = (name: keyof AcceptedState) => {
    setAccepted({ yes: name === "yes", no: name === "no" });
    onClickCheck && onClickCheck(name === "yes");
  };

  const handleClickProceed = () => {
    if (!Object.values(accepted).includes(true)) {
      return errorToast(`Kindly click "Accept" or "Do not Accept" to proceed`);
    }
    setError("");
    onClickProceed && onClickProceed();
  };

  return (
    <div className={styles.tncWrapper}>
      <div className={styles.tncContent}>
        {accountType.includes("Swift") ? <SwiftTandC /> : <MainTandC />}
      </div>
      <div className={styles.tncControls}>
        <div className={styles.tncRadioBtns}>
          <p>
            <RadioBtn
              onClickCheck={() => handleToggleAccept("yes")}
              checked={accepted.yes}
            />
            <span>Accept</span>
          </p>
          <p>
            <RadioBtn
              onClickCheck={() => handleToggleAccept("no")}
              checked={accepted.no}
            />
            <span>Do not accept</span>
          </p>
        </div>
        {error && <span className={styles.error}>{error}</span>}
        <button
          className="btn"
          onClick={handleClickProceed}
          disabled={!accepted.no && !accepted.yes}
        >
          Proceed
        </button>
      </div>
    </div>
  );
};

export default TermsAndConditions;
